module.exports = __webpack_public_path__ + "img/aer-logo-footer.d1189d1e.png";